import React from 'react';
import PropTypes from 'prop-types';
import { FieldTable } from '../../../components/FieldTable/FieldTable';
import { FieldTableColumnProps } from 'components/FieldTable/FieldTableTypes';
import { SiteHealthAndSafety } from 'generated/graphql';
import { uniqueId } from '../../../utils';
import {SiteHealthAndSafetyTypeSelect} from "../../../components/MaterialSelects/SiteHealthAndSafetyTypeSelect";


const columns:FieldTableColumnProps<SiteHealthAndSafety>[] = [
    {
        header:'Type',
        accessor:'healthAndSafetyType',
        sort:'healthAndSafetyType.label',
        dataType:'select',
        options: {
            label:'label',
            renderEditor: ({ field}) =>
        <SiteHealthAndSafetyTypeSelect {...field} autoFocus={true} error={field.error} />,
        }
    },
    {
        header: 'Notes',
        accessor: 'notes',
        dataType:'text'
    },
    {
        header: 'Date',
        accessor: 'last_inspection_date',
        dataType:'date'
    }
];
function newRow(): SiteHealthAndSafety {
    return { id: uniqueId() };
}

const HealthAndSafetyPane = ({values,setValue,readOnly})=> {
    return (
        <FieldTable columns={columns}
         name="siteHealthAndSafeties" 
        values={values}
        className="site-health-and-safety"
        setValue={setValue}
        newRow={newRow}
        readOnly={readOnly}
        newRowLabel="Add Health &amp; Safety event"
        />
        );
}

HealthAndSafetyPane.propTypes = {
    health_and_safety:PropTypes.array
};

export default HealthAndSafetyPane;

